import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type ManualApplicationFileSearchParams, type StoreBaseReturn } from '@shared/api';

interface UseRejectManualApplicationFileStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  rejectManualApplicationFile: (searchParams: ManualApplicationFileSearchParams, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useRejectManualApplicationFileStore = create<UseRejectManualApplicationFileStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  rejectManualApplicationFile: async (searchParams, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await ApplicationApi.rejectManualApplicationFile(searchParams, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
